module.exports = __webpack_public_path__ + "img/result_obj02.c014b087.png";